import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import Button from 'src/components/buttons/button';
import Modal from 'src/modules/shared/modal/components/modal';
import FollowSuccessMessage from 'src/modules/community/shared/components/alert/followSuccessMessage';

import { showSignupModal, showModal } from 'src/modules/shared/modal/actions';
import { connect } from 'react-redux';
import signupContext from 'src/constants/signupContext';
import { trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

export const onWriteClick = ({ community, currentUser, onFollow, showSignupModal, showModal, trackingSection }) => {
  if (!currentUser) {
    showSignupModal(
      {
        element: signupContext.element.WRITE,
        section: signupContext.section.COMMUNITY,
      },
      community,
    );
    trackFootfallEvent(footfallEventTypes.CLICKED, {
      clickType: 'sign-up',
      clickMetadata: { section: trackingSection, element: 'write-post' },
    });
  } else if (!currentUser.followedCommunities.find(x => x.slug === community.slug)) {
    showModal(
      <Modal
        accept={i18n.t('Follow')}
        cancel={i18n.t('Cancel')}
        title={i18n.t('Write a post')}
        onAccept={async () => {
          await onFollow(community, currentUser.userId, <FollowSuccessMessage communityName={community.name}/>);
          setTimeout(() => {
            window.location.href = `/${community.slug}/write`;
          }, 500);
        }}
      >
        {i18n.t('You need to follow this community to be able to write a post or ask a question')}
      </Modal>,
    );
  } else {
    window.location.href = `/${community.slug}/write`;
  }
};

const WriteButton = ({
  className,
  community,
  currentUser,
  onFollow,
  children,
  showSignupModal,
  showModal,
  trackingSection,
}) => (
  <Button
    className={className}
    icon="pencil-1"
    onClick={() => onWriteClick({ community, currentUser, onFollow, showSignupModal, showModal, trackingSection })}
  >
    {children}
  </Button>
);

WriteButton.propTypes = {
  community: PropTypes.object.isRequired,
  trackingSection: PropTypes.string.isRequired,
  className: PropTypes.string,
  currentUser: PropTypes.object,
  onFollow: PropTypes.func,
};

WriteButton.defaultProps = {
  currentUser: null,
  className: '',
  onFollow: () => {},
};

export default connect(null, { showSignupModal, showModal })(WriteButton);



// WEBPACK FOOTER //
// ./src/modules/community/shared/components/writeButton.js